import React, { useState, useEffect } from 'react';
import FourPillars from '../components/FourPillars';

const ThreePLDistributorsPage = () => {
  const [activeSection, setActiveSection] = useState('');

  useEffect(() => {
    const handleScroll = () => {
      const sections = [
        'why-choose',
        'solutions',
        'key-benefits'
      ];
      
      const scrollPosition = window.scrollY + 150;
      
      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i]);
        if (section && section.offsetTop <= scrollPosition) {
          setActiveSection(sections[i]);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 100;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      setActiveSection(sectionId);
    }
  };

  return (
    <main className="services">
      <div className="container">
        <div className="sv-content-wrapper">
          <div className="sv-main-content">
            {/* Hero */}
            <section className="sv-hero">
              <div className="sv-eyebrow">3PL & Distributors</div>
              <h1 className="sv-title">Logistics and Distribution Solutions for 3PL Providers</h1>
              <p className="sv-subtitle">Specialized solutions for third-party logistics providers and distributors to handle abandoned freight, returns processing, and excess inventory management. Streamline operations and recover value while maintaining service excellence.</p>
            </section>

            {/* Why Choose */}
            <section id="why-choose" className="sv-features">
              <h2 className="sv-section-title">Why 3PL & Distributors Choose Us</h2>
        <div className="sv-features-grid">
          <div className="sv-feature">
            <h4>Rapid Resolution</h4>
            <p>Fast turnaround times to clear dock space and resolve abandoned freight claims, typically within 48-72 hours.</p>
          </div>
          <div className="sv-feature">
            <h4>Compliance Expertise</h4>
            <p>Full compliance with freight regulations, chain-of-custody requirements, and documentation standards for logistics operations.</p>
          </div>
          <div className="sv-feature">
            <h4>Value Recovery</h4>
            <p>Maximize recovery from abandoned freight, returns, and excess inventory through strategic multi-channel routing.</p>
          </div>
          <div className="sv-feature">
            <h4>Operational Efficiency</h4>
            <p>Streamline operations by outsourcing complex disposition tasks while maintaining focus on core logistics services.</p>
          </div>
        </div>
      </section>

            {/* Solutions */}
            <section id="solutions" className="sv-overview">
              <h2 className="sv-section-title">Solutions for 3PL & Distributors</h2>
        <ul className="sv-bullets sv-list">
          <li>Abandoned Freight Resolution – Rapid processing of abandoned shipments to clear dock space and recover value</li>
          <li>Returns Processing – Efficient handling of customer returns with sorting, grading, and strategic routing</li>
          <li>Excess Inventory Management – Liquidate excess inventory from distribution centers and fulfillment operations</li>
          <li>Freight Claim Processing – Complete documentation and processing of freight claims with carriers</li>
          <li>Warehouse Clearance – Clear warehouse space by disposing of damaged, expired, or obsolete inventory</li>
          <li>Compliance Support – Ensure compliance with regulations, documentation requirements, and environmental standards</li>
        </ul>
      </section>

            {/* Benefits */}
            <section id="key-benefits" className="sv-overview">
              <h2 className="sv-section-title">Key Benefits</h2>
        <ul className="sv-bullets sv-list">
          <li>Free up dock and warehouse space quickly</li>
          <li>Reduce storage costs and operational overhead</li>
          <li>Maintain service excellence by outsourcing complex tasks</li>
          <li>Recover value from abandoned freight and excess inventory</li>
          <li>Ensure compliance with all regulatory requirements</li>
          <li>Gain detailed reporting and documentation for clients</li>
        </ul>
      </section>

            {/* Four Pillars */}
            <FourPillars />

            {/* CTA */}
            <section className="sv-cta">
              <div className="sv-cta-inner">
                <h3>Ready to optimize your 3PL operations?</h3>
                <p>Get a free assessment and discover how we can streamline your logistics and distribution operations.</p>
                <div className="sv-cta-actions">
                  <a className="btn btn-primary" href="tel:+18778739336">Call (877) 873-9336</a>
                  <a className="btn btn-secondary" href="mailto:info@globoflo.com">Email Us</a>
                </div>
              </div>
            </section>
          </div>

          {/* Quick Links Sidebar */}
          <aside className="sv-quick-links">
            <h3 className="sv-quick-links-title">3PL & Distributors</h3>
            <nav className="sv-quick-links-nav">
              <ul>
                <li>
                  <button 
                    className={activeSection === 'why-choose' ? 'active' : ''}
                    onClick={() => scrollToSection('why-choose')}
                  >
                    Why 3PL & Distributors Choose Us
                  </button>
                </li>
                <li>
                  <button 
                    className={activeSection === 'solutions' ? 'active' : ''}
                    onClick={() => scrollToSection('solutions')}
                  >
                    Solutions for 3PL & Distributors
                  </button>
                </li>
                <li>
                  <button 
                    className={activeSection === 'key-benefits' ? 'active' : ''}
                    onClick={() => scrollToSection('key-benefits')}
                  >
                    Key Benefits
                  </button>
                </li>
              </ul>
            </nav>
          </aside>
        </div>
      </div>
    </main>
  );
};

export default ThreePLDistributorsPage;

